import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installMusic } from './audio/install';
import { boot } from './bridge/boot';
import { netBase } from './bridge/embedded';
import { DEFAULT_MUSIC_VOLUME, hasPersistedMusicVolume, store } from './store/store';
import './shell/theme.css';

// Fonts are produced by the asset pipeline (`pnpm assets`); the stylesheet is optional and every
// font stack in theme.css has a system fallback, so a 404 here costs nothing.
const fonts = document.createElement('link');
fonts.rel = 'stylesheet';
fonts.href = `${netBase()}/assets/fonts/fonts.css`;
document.head.appendChild(fonts);

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Bridge → identity → store; the shell renders the boot screen meanwhile.
boot().catch((err: unknown) => console.error('[boot] failed', err));

// Music beds. Installed here rather than from the shell or the table scene because they are the
// one piece of audio whose lifetime is the session: the lobby loop plays on the boot screen,
// before any table exists, and outlives every table built afterwards. Nothing is fetched until
// the engine unlocks, and nothing at all when the music slider sits at zero.
installMusic({
  state: () => store.getState(),
  subscribeState: (cb) => store.subscribe(cb),
  setMusicVolume: (music) => store.getState().setVolume({ music }),
  hasStoredVolume: hasPersistedMusicVolume,
  platformDefaults: DEFAULT_MUSIC_VOLUME,
});
